import Slider from "react-slick";
import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import styles from "./news.module.sass";
import { NextArrow, PrevArrow } from "../components/sliderArrow";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function BasicTabs() {
  const [value, setValue] = useState(0);
  const [articles, setArticles] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [currentArticle] = useState({ title: "", content: "" });

  const sliderSettings = {
    dots: false, // 显示点导航
    infinite: false, // 无限循环
    speed: 500, // 切换速度
    slidesToShow: 4, // 显示的幻灯片数量
    slidesToScroll: 4, // 滚动的幻灯片数量
    prevArrow: <PrevArrow customClassName={styles.prevArrow} />,
    nextArrow: <NextArrow customClassName={styles.nextArrow} />,
    responsive: [
      {
        breakpoint: 1350,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 766,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
        },
      },
      {
        breakpoint: 375,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleOpenArticle = (article) => {
    if (article.redirectUrl) {
      window.open(article.redirectUrl, "_blank", "noopener noreferrer");
    } else {
      let url = `/page3?id=${article.pageID}`;
      window.open(url, "_blank", "noopener noreferrer");
    }
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  useEffect(() => {
    fetch("/api/homepage/articleList")
      .then((response) => response.json())
      .then((data) => {
        setArticles(data.data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  }, []);

  return (
    <Box className="news-root">
      <Tabs
        value={value}
        onChange={handleChange}
        aria-label="basic tabs example"
        sx={{
          "& .MuiTabs-indicator": {
            display: "none",
          },
        }}
      >
        {articles.map((item, index) => (
          <Tab key={`tab${item.id}-${index}`} label={item.category} {...a11yProps(index)} />
        ))}
      </Tabs>
      <div className="mt-6 mx-auto">
        {articles.map((item, index) => (
          <CustomTabPanel key={`customTabPanel${item.id}-${index}`} value={value} index={index}>
            <Slider {...sliderSettings}>
              {item.article.map((article) => (
                <div className="p-2 bg-white" key={`article${article.postID}-${index}`}>
                  <div className="border border-[#d0d0d0]">
                    <div
                      className="aspect-[212/184] w-full bg-cover bg-center bg-no-repeat"
                      style={{ backgroundImage: `url(${article.thumbnailUrl})` }}
                    />
                    <div className="h-[160px] p-4 text-left mobile:p-3">
                      <p className="text-xl mb-4 text-[#343434] table:text-xl mobile:text-lg mobile:mb-2">
                        {article.intro}
                      </p>
                      <p className="text-[#202020] text-2xl font-bold overflow-hidden" style={{
                        display: '-webkit-box',
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: 'vertical'
                      }}>
                        {article.title}
                      </p>
                    </div>
                    <div className="bg-[#d7b15b] border border-[#d0d0d0] p-4 mobile:p-2 cursor-pointer hover:bg-[#dbba6c] duration-150">
                      <a
                        href="javascript:void(0)"
                        className="text-black text-2xl table:text-xl mobile:text-lg"
                        onClick={() => handleOpenArticle(article)}
                      >
                        查看更多
                      </a>
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          </CustomTabPanel>
        ))}
      </div>
      <CustomizedDialogs
        title={currentArticle.title}
        content={currentArticle.content}
        open={openDialog}
        onClose={handleCloseDialog}
      />
    </Box>
  );
}

// 點開之後的容器
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

export function CustomizedDialogs(props) {
  const { title, content, open, onClose } = props;

  return (
    <BootstrapDialog onClose={onClose} aria-labelledby="customized-dialog-title" open={open}>
      <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
        {title}
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent dividers>{content}</DialogContent>
      <DialogActions>
        <Button autoFocus onClick={onClose}>
          Close
        </Button>
      </DialogActions>
    </BootstrapDialog>
  );
}

CustomizedDialogs.propTypes = {
  title: PropTypes.string,
  content: PropTypes.string,
  open: PropTypes.bool,
  onClose: PropTypes.func,
};
